import { c as _c } from "react/compiler-runtime";
import type { ElementType, HTMLAttributes, ReactElement } from 'react';
import { cn } from '#cn';
import { alignClasses, directionClasses, gapClasses, justifyClasses, type LayoutAlign, type LayoutDirection, type LayoutGap, type LayoutJustify } from './layout-classes';
export type StackProps = HTMLAttributes<HTMLElement> & {
  direction: LayoutDirection;
  gap?: LayoutGap;
  align?: LayoutAlign;
  justify?: LayoutJustify;
  wrap?: boolean;
  as?: ElementType;
};

/** A flexbox layout primitive with a required `direction` and the shared gap/align/justify scale — `HStack`/`VStack` are its two fixed-direction shorthands. */
export const Stack = t0 => {
  const $ = _c(22);
  let align;
  let children;
  let className;
  let direction;
  let gap;
  let justify;
  let props;
  let t1;
  let wrap;
  if ($[0] !== t0) {
    ({
      direction,
      gap,
      align,
      justify,
      wrap,
      as: t1,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = align;
    $[2] = children;
    $[3] = className;
    $[4] = direction;
    $[5] = gap;
    $[6] = justify;
    $[7] = props;
    $[8] = t1;
    $[9] = wrap;
  } else {
    align = $[1];
    children = $[2];
    className = $[3];
    direction = $[4];
    gap = $[5];
    justify = $[6];
    props = $[7];
    t1 = $[8];
    wrap = $[9];
  }
  const Tag = t1 === undefined ? "div" : t1;
  const t2 = directionClasses[direction];
  const t3 = gap !== undefined && gapClasses[gap];
  const t4 = align && alignClasses[align];
  const t5 = justify && justifyClasses[justify];
  const t6 = wrap && "flex-wrap";
  let t7;
  if ($[10] !== className || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = cn("flex", t2, t3, t4, t5, t6, className);
    $[10] = className;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== Tag || $[18] !== children || $[19] !== props || $[20] !== t7) {
    t8 = <Tag className={t7} {...props}>{children}</Tag>;
    $[17] = Tag;
    $[18] = children;
    $[19] = props;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};